import React, { useState, useCallback } from "react";
import {
  TextField,
  Button,
  InputAdornment,
  Alert,
  CircularProgress,
  Paper,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import FlightIcon from "@mui/icons-material/Flight";
import useParcelSearch from "../../hooks/useParcelSearch";

const ParcelSearch = ({ onParcelFound }) => {
  const [parcelId, setParcelId] = useState("");
  const { searchParcel, isLoading, error, successMessage, clearMessages } =
    useParcelSearch();

  const handleSubmit = useCallback(
    async (e) => {
      e.preventDefault();

      try {
        const parcelData = await searchParcel(parcelId);
        if (parcelData && onParcelFound) {
          onParcelFound(parcelData);
        }
      } catch (error) {
        // Error is handled by the mutation hook, no need to do anything here
        console.log("Search failed:", error.message);
      }
    },
    [parcelId, searchParcel, onParcelFound]
  );

  const handleInputChange = useCallback(
    (e) => {
      setParcelId(e.target.value);
      if (error || successMessage) {
        clearMessages();
      }
    },
    [error, successMessage, clearMessages]
  );

  return (
    <Paper
      component="form"
      onSubmit={handleSubmit}
      elevation={2}
      sx={{
        position: "absolute",
        top: 10,
        right: 325,
        zIndex: 1000,
        backgroundColor: "rgba(255, 255, 255, 0.95)",
        backdropFilter: "blur(4px)",
      }}
    >
      <TextField
        value={parcelId}
        onChange={handleInputChange}
        placeholder="Fly to Parcel"
        variant="outlined"
        size="small"
        disabled={isLoading}
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                <Button
                  type="submit"
                  variant="text"
                  disabled={isLoading || !parcelId.trim()}
                  sx={{
                    minWidth: "auto",
                    p: 0.5,
                    color:
                      isLoading || !parcelId.trim()
                        ? "text.disabled"
                        : "primary.main",
                  }}
                >
                  {isLoading ? (
                    <CircularProgress size={16} color="inherit" />
                  ) : (
                    <FlightIcon fontSize="small" />
                  )}
                </Button>
              </InputAdornment>
            ),
          },
        }}
        sx={{ width: "240px" }}
      />

      {(error || successMessage) && (
        <Alert
          severity={error ? "error" : "success"}
          sx={{
            fontSize: "0.75rem",
            "& .MuiAlert-message": {
              padding: "4px 0",
            },
          }}
        >
          {error || successMessage}
        </Alert>
      )}
    </Paper>
  );
};

export default ParcelSearch;
